import { initProductBuyTile } from '../../../snippets/product-buy-tile-bundle/product-buy-tile-bundle';

export const initBundlesSectionTiles = () => {
  const bundleProductEls = document.querySelectorAll(
    '[data-list-collections-bundles-product]'
  );

  bundleProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-bundles-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
